import type { AxiosResponse } from 'axios';
import API_ENDPOINTS from '../../../../apiEndpoints';
import { axiosInstanceForLambda } from '../../../../library/Axios';

export type CreateGoogleUserPasswordRequest = {
  password: string;
};

export type CreateGoogleUserPasswordResponse = {
  message?: string;
  error?: string;
  email?: string;
  code?: string;
};

export type CreateGoogleUserPasswordErrorData = {
  code?: string;
  message?: string;
  error?: string;
  errorMessage?: string;
};

/**
 * Creates a password for a Google-authenticated user via the NEW_PASSWORD lambda.
 */
export const createGoogleUserPasswordApi = (
  payload: CreateGoogleUserPasswordRequest
): Promise<AxiosResponse<CreateGoogleUserPasswordResponse>> =>
  axiosInstanceForLambda.post(API_ENDPOINTS.NEW_PASSWORD, payload);
